import styled, { css } from "styled-components";

export const Table = styled.table`
  border: 2px solid grey;
  border-collapse: collapse;
  margin: 0 auto;
`;

export const TableRow = styled.tr<{
  $header?: Boolean;
}>`
  border: 1px solid grey;
  font-size: large;

  ${({ $header }) =>
    $header &&
    css`
      color: orange;
      background-color: black;
      text-transform: uppercase;
    `}

  @media (max-width: 678px) {
    font-size: small;
  }
`;

const cell = css`
  border: 1px solid grey;
  padding: 10px;
`;

export const TableHeader = styled.th`
  ${cell}
`;

export const TableData = styled.td`
  ${cell}

  &:hover {
    color: black;
    background: darkgray;
  }
`;
